<div class="dialog-container">
    <!-- Dialog Header -->
    <div class="dialog-header d-flex justify-content-between align-items-center mb-4">
        <h4 class="dialog-title mb-0">Join Meeting - {{ meetingTitle }}</h4>
        <button type="button" class="close-btn" (click)="minimizeDialog()" aria-label="Minimize dialog" title="Minimize">
            <i class="bi bi-dash-lg"></i>
        </button>
    </div>

    <!-- Back to agenda list link -->
    <div class="mb-3" style="padding: 0 20px;">
        <a href="#" class="back-link" (click)="goBackToAgendaList(); $event.preventDefault()">
            <i class="fas fa-arrow-left me-2"></i> Back to agenda list
        </a>
    </div>

    <!-- Agenda Items Navigation -->
    <div class="agenda-navigation mb-3" *ngIf="agendaItems.length > 1" style="margin: 0 20px 12px 20px;">
        <div class="agenda-items-list" #agendaItemsList>
            <div 
                *ngFor="let item of agendaItems; let i = index" 
                class="agenda-item-tab"
                [class.active]="i === currentAgendaIndex">
                <span class="agenda-tab-number">{{ item.order || (i + 1) }}</span>
                <span class="agenda-tab-subject">{{ item.subject }}</span><span class="agenda-stage-pill" [ngClass]="getAgendaStageClass(item.currentStage)" *ngIf="item.currentStage">{{ item.currentStage }}</span>
                <i class="fas fa-check-circle agenda-tab-check" *ngIf="acceptedAgendaItems.has(i)"></i>
                <i class="fas fa-times-circle agenda-tab-reject" *ngIf="rejectedAgendaItems.has(i)"></i>
                <i class="fas fa-clock agenda-tab-defer" *ngIf="deferredAgendaItems.has(i)"></i>
            </div>
        </div>
    </div>

    <!-- Dialog Content -->
    <form [formGroup]="commentForm" *ngIf="currentAgendaItem" class="dialog-form">
        <div class="dialog-content-scrollable">
        <!-- Agenda Title Section -->
        <div class="form-section">
            <h5 class="section-title fw-bold">Agenda Title</h5>
            <div class="agenda-title-box">
                <div class="agenda-subject fw-bold d-flex align-items-center gap-2 flex-wrap">{{ currentAgendaItem?.subject || 'N/A' }}<span class="agenda-stage-pill" [ngClass]="getAgendaStageClass(currentAgendaItem?.currentStage)" *ngIf="currentAgendaItem?.currentStage">{{ currentAgendaItem?.currentStage }}</span></div>
                <div class="agenda-datetime text-muted mt-2">{{ currentAgendaItem?.dateTime || 'N/A' }}</div>
            </div>
        </div>

        <!-- Agenda Description Section -->
        <div class="form-section">
            <h5 class="section-title fw-bold">Agenda Description</h5>
            <div class="row">
                <div class="col-12 col-md-6 mb-3 mb-md-0">
                    <div class="description-column">
                        <div class="description-label fw-bold mb-2">English</div>
                        <div class="description-content p-3">
                            {{ getAgendaDescriptionEN() || 'No English description available.' }}
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="description-column">
                        <div class="description-label fw-bold mb-2">العربية (Arabic)</div>
                        <div class="description-content p-3">
                            {{ getAgendaDescriptionAR() || 'لا يوجد وصف بالعربية.' }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- Required from Tender Committee -->
            <div class="mt-3">
                <h6 class="fw-bold mb-2">Required from Tender Committee</h6>
                <textarea 
                    class="form-control" 
                    rows="4"
                    [readonly]="true"
                    [value]="currentAgendaItem?.requiredFromTC || ''"
                    placeholder="No requirements specified...">
                </textarea>
            </div>
        </div>

            <!-- TC Notes -->
            <div class="form-section">
                <h5 class="section-title fw-bold">TC Notes</h5>
                <div class="row">
                    <div class="col-12 mb-3 mb-md-0">
                        <div class="description-column">
                            <div class="description-label fw-bold mb-2">Notes</div>
                            <div class="description-content p-3">
                                {{ currentAgendaItem?.tcNotes || 'No TC Notes available.' }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        <!-- Bid Unsealing Section -->
        <div class="form-section" *ngIf="shouldShowUnsealSection">
            <h5 class="section-title fw-bold">{{ unsealSectionTitle }}</h5>
            <div *ngIf="isLoadingUnsealBids" class="text-muted p-3 bg-light rounded">
                <i class="fas fa-spinner fa-spin me-2"></i>Loading related bids...
            </div>
            <div *ngIf="!isLoadingUnsealBids && visibleUnsealBidsForMember.length === 0" class="text-muted p-3 bg-light rounded">
                <i class="fas fa-info-circle me-2"></i>No related bids found for this agenda item.
            </div>
            <div class="table-responsive" *ngIf="!isLoadingUnsealBids && visibleUnsealBidsForMember.length > 0">
                <table class="table unseal-bids-table mb-0">
                    <thead>
                        <tr>
                            <th>Bid ID</th>
                            <th>Vendor</th>
                            <th>Bid Amount</th>
                            <th>Bid Valid Till</th>
                            <th>Documents</th>
                            <th>Confirmations</th>
                            <th class="text-end">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let bid of visibleUnsealBidsForMember" [class.unsealed-row]="isBidUnsealedForScope(bid)">
                            <td class="fw-bold">{{ bid.bidId }}</td>
                            <td>{{ bid.vendorName || bid.vendorId || '-' }}</td>
                            <td>{{ formatBidAmount(bid.bidAmount) }}</td>
                            <td>{{ formatBidDate(bid.bidValidTill) }}</td>
                            <td>
                                <ng-container *ngIf="getVisibleUnsealDocuments(bid).length > 0; else sealedDocumentState">
                                    <div class="unseal-doc-link" *ngFor="let document of getVisibleUnsealDocuments(bid)">
                                        <i class="fas fa-file-alt me-1"></i>
                                        <button type="button" class="unseal-link-button" (click)="openUnsealDocument(document)" [disabled]="isUnsealDocumentDownloading(document)">
                                            <ng-container *ngIf="isUnsealDocumentDownloading(document); else unsealDocumentName">
                                                <i class="fas fa-spinner fa-spin me-1"></i>Downloading...
                                            </ng-container>
                                            <ng-template #unsealDocumentName>{{ document.name || document.attachmentFor || 'Document' }}</ng-template>
                                        </button>
                                        <span class="text-muted small" *ngIf="formatUnsealFileSize(document.fileSize)">({{ formatUnsealFileSize(document.fileSize) }})</span>
                                    </div>
                                </ng-container>
                                <ng-template #sealedDocumentState>
                                    <div>{{ getUnsealDocumentSummary(bid) }}</div>
                                    <span class="unseal-status" [class.unsealed]="isBidUnsealedForScope(bid)">{{ getScopeStatusText(bid) }}</span>
                                </ng-template>
                                <button type="button" class="btn btn-sm btn-outline-secondary mt-2" (click)="openBidDocumentsDialog(bid)"><i class="fas fa-folder-open me-1"></i>Bid documents</button>
                            </td>
                            <td>
                                <span class="unseal-count" *ngIf="!isCommercialUnsealBlockedByTechnicalRejection(bid); else technicallyRejectedState">{{ getUnsealConfirmationText(bid) }}</span>
                                <ng-template #technicallyRejectedState><span class="unseal-status text-center">Rejected Evaluation</span></ng-template>
                            </td>
                            <td class="text-end">
                                <button type="button" class="btn btn-sm broadcast-btn" (click)="voteToUnsealBid(bid)" [disabled]="isObserver || isCommercialUnsealBlockedByTechnicalRejection(bid) || hasCurrentUserUnsealVoted(bid) || isBidUnsealedForScope(bid) || !hasBidDocumentForScope(bid)">
                                    {{ isCommercialUnsealBlockedByTechnicalRejection(bid) ? 'Rejected' : (isBidUnsealedForScope(bid) ? 'Unsealed' : (hasCurrentUserUnsealVoted(bid) ? 'Confirmed' : 'Unseal')) }}
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="form-section" *ngIf="isEvaluationReviewStage">
            <h5 class="section-title fw-bold">Evaluation Review</h5>
            <div class="table-responsive mb-3" *ngIf="!isLoadingUnsealBids && unsealBids.length">
                <table class="table linked-evaluations-table mb-0"><thead><tr><th>Bid ID</th><th>Vendor</th><th>Amount</th><th>Documents</th><th>Evaluations</th></tr></thead><tbody>
                    <tr *ngFor="let bid of unsealBids"><td class="fw-bold">{{ bid.bidId }}</td><td>{{ bid.vendorName || '-' }}</td><td>{{ formatBidAmount(bid.bidAmount) }}</td><td><button type="button" class="btn btn-sm btn-outline-secondary" (click)="openBidDocumentsDialog(bid)">Documents</button></td><td><div *ngFor="let evaluation of bid.evaluations || []">{{ evaluation.evaluationType }}: {{ evaluation.decision || evaluation.status || '-' }}</div></td></tr>
                </tbody></table>
            </div>
            <div *ngIf="isLoadingEvaluationReviews" class="text-muted p-3 bg-light rounded"><i class="fas fa-spinner fa-spin me-2"></i>Loading evaluations...</div>
            <div *ngIf="!isLoadingEvaluationReviews && evaluationReviewItems.length === 0" class="text-muted p-3 bg-light rounded">No evaluations found for this agenda PR.</div>
            <div class="table-responsive" *ngIf="!isLoadingEvaluationReviews && evaluationReviewItems.length">
                <table class="table linked-evaluations-table mb-0">
                    <thead><tr><th>Evaluation ID</th><th>Type</th><th>Evaluator(s)</th><th>Status</th><th>Report</th><th>Evaluator Comments</th><th>Action</th><th *ngIf="hasSecretaryChangeRequest()">Secretary Comments</th></tr></thead>
                    <tbody>
                        <tr *ngFor="let evaluation of evaluationReviewItems">
                            <td class="fw-bold">{{ evaluation.evaluationId }}</td>
                            <td>{{ evaluation.evaluationType || '-' }}</td>
                            <td>{{ evaluation.assignedTo || '-' }}</td>
                            <td><span class="evaluation-status">{{ evaluation.status }}</span></td>
                            <td>
                                <div *ngFor="let report of evaluation.reports || []"><button type="button" class="btn btn-sm btn-outline-secondary" (click)="downloadEvaluationReport(report)">Evaluation Report</button></div>
                                <span *ngIf="!(evaluation.reports || []).length" class="text-muted">No report uploaded</span>
                            </td>
                            <td><button type="button" class="btn btn-sm btn-outline-secondary" (click)="showEvaluatorComments(evaluation)">Evaluator Comments</button></td>
                            <td>{{ getEvaluationReviewActionText(evaluation) }}</td>
                            <td *ngIf="hasSecretaryChangeRequest()">{{ getEvaluationReviewActionText(evaluation) === 'Change Request' ? getEvaluationReviewComments(evaluation) : '-' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="form-section" *ngIf="shouldShowBidContext && !isEvaluationReviewStage">
            <h5 class="section-title fw-bold">Related Evaluations</h5>
            <div class="table-responsive" *ngIf="!isLoadingEvaluationReviews && evaluationReviewItems.length">
                <table class="table linked-evaluations-table mb-0"><thead><tr><th>Evaluation ID</th><th>Type</th><th>Evaluator(s)</th><th>Status</th><th>Report</th><th>Evaluator Comments</th><th>Action</th><th *ngIf="hasSecretaryChangeRequest()">Secretary Comments</th></tr></thead><tbody>
                    <tr *ngFor="let evaluation of evaluationReviewItems"><td class="fw-bold">{{ evaluation.evaluationId }}</td><td>{{ evaluation.evaluationType || '-' }}</td><td>{{ evaluation.assignedTo || '-' }}</td><td>{{ evaluation.status || '-' }}</td><td><div *ngFor="let report of evaluation.reports || []"><button type="button" class="btn btn-sm btn-outline-secondary" (click)="downloadEvaluationReport(report)">Evaluation Report</button></div><span *ngIf="!(evaluation.reports || []).length" class="text-muted">No report uploaded</span></td><td><button type="button" class="btn btn-sm btn-outline-secondary" (click)="showEvaluatorComments(evaluation)">Evaluator Comments</button></td><td>{{ getEvaluationReviewActionText(evaluation) }}</td><td *ngIf="hasSecretaryChangeRequest()">{{ getEvaluationReviewActionText(evaluation) === 'Change Request' ? getEvaluationReviewComments(evaluation) : '-' }}</td></tr>
                </tbody></table>
            </div>
            <div *ngIf="!isLoadingEvaluationReviews && !evaluationReviewItems.length" class="text-muted">No related evaluations found.</div>
        </div>

        <div class="form-section" *ngIf="isAwardBidStage">
            <h5 class="section-title fw-bold">Tender Committee Award Decision</h5>
            <div *ngIf="isLoadingAwardBids" class="text-muted p-3 bg-light rounded"><i class="fas fa-spinner fa-spin me-2"></i>Loading bids and evaluations...</div>
            <div *ngIf="!isLoadingAwardBids && awardBids.length === 0" class="text-muted p-3 bg-light rounded">No related bids found for this agenda PR.</div>
            <div class="table-responsive" *ngIf="!isLoadingAwardBids && awardBids.length">
                <table class="table linked-evaluations-table mb-0">
                    <thead><tr><th>Bid ID</th><th>Vendor</th><th>Amount</th><th>Valid Till</th><th>Evaluation Result</th><th>Documents</th><th>Committee Status</th></tr></thead>
                    <tbody>
                        <tr *ngFor="let bid of awardBids">
                            <td class="fw-bold">{{ bid.bidId }}</td><td>{{ bid.vendorName || '-' }}</td><td>{{ formatBidAmount(bid.bidAmount) }}</td><td>{{ formatBidDate(bid.bidValidTill) }}</td>
                            <td>{{ bid.evaluations?.[0]?.decision || bid.evaluations?.[0]?.status || '-' }}</td>
                            <td><button type="button" class="btn btn-sm btn-outline-secondary" (click)="openBidDocumentsDialog(bid)"><i class="fas fa-folder-open me-1"></i>Documents</button></td>
                            <td><span class="evaluation-status">{{ getCommitteeBidStatus(bid) }}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- TC Decision Section (Read-only for TC Members) -->
        <div class="form-section">
            <h5 class="section-title fw-bold">TC Decision</h5>
            <div class="row">
                <div class="col-12 col-md-6 mb-3 mb-md-0">
                    <div class="form-group">
                        <label class="form-label fw-bold mb-2">TC Decision EN</label>
                        <div
                            class="readonly-rich-content"
                            [class.is-empty]="!getTCDecisionEN()"
                            [innerHTML]="getTrustedDecisionHtml(getTCDecisionEN(), 'No TC Decision in English...')">
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label class="form-label fw-bold mb-2">TC Decision AR</label>
                        <div
                            class="readonly-rich-content arabic-content"
                            [class.is-empty]="!getTCDecisionAR()"
                            [innerHTML]="getTrustedDecisionHtml(getTCDecisionAR(), 'No TC Decision in Arabic...')">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Attachments Section -->
        <div class="form-section" *ngIf="currentAgendaItemAttachments.length > 0 || isLoadingAttachments">
            <h5 class="section-title fw-bold mb-3">
                <i class="fas fa-paperclip me-2"></i>Attachments
            </h5>
            <div *ngIf="isLoadingAttachments" class="text-muted p-3 bg-light rounded">
                <i class="fas fa-spinner fa-spin me-2"></i>Loading attachments...
            </div>
            <div class="attachments-list" *ngIf="!isLoadingAttachments">
                <div *ngFor="let attachment of currentAgendaItemAttachments" class="attachment-item d-flex align-items-center p-3 mb-2 rounded">
                    <div class="attachment-icon me-3 flex-shrink-0">
                        <i class="fas fa-file-pdf text-danger" *ngIf="attachment.fileType === 'application/pdf'"></i>
                        <i class="fas fa-file-word text-primary" *ngIf="attachment.fileType?.includes('word')"></i>
                        <i class="fas fa-file-image text-info" *ngIf="attachment.fileType?.includes('image')"></i>
                        <i class="fas fa-file text-secondary" *ngIf="!attachment.fileType?.includes('pdf') && !attachment.fileType?.includes('word') && !attachment.fileType?.includes('image')"></i>
                    </div>
                    <div class="attachment-info flex-grow-1 min-w-0">
                        <div class="attachment-name fw-bold" [title]="attachment.originalName || attachment.name">{{ attachment.originalName || attachment.name }}</div>
                        <div class="attachment-size text-muted small">{{ attachment.size }}</div>
                    </div>
                    <div class="attachment-actions flex-shrink-0 ms-3">
                        <button 
                            type="button"
                            class="btn btn-sm btn-outline-primary me-2"
                            (click)="downloadAttachment(attachment); $event.stopPropagation()">
                            <i class="fas fa-download me-1"></i>Download
                        </button>
                        <button 
                            type="button" 
                            class="btn btn-sm btn-outline-secondary"
                            (click)="previewAttachment(attachment); $event.stopPropagation()"
                            title="Preview">
                            <i class="fas fa-eye me-1"></i>Preview
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-section" *ngIf="currentAgendaItemAttachments.length === 0 && isLoadingAttachments === false">
            <h5 class="section-title fw-bold mb-3">
                <i class="fas fa-paperclip me-2"></i>Attachments
            </h5>
            <div class="text-muted p-3 bg-light rounded">
                <i class="fas fa-info-circle me-2"></i>No attachments available for this agenda item.
            </div>
        </div>

        <!-- Your Comment Section (Hidden for Observers) -->
        <div class="form-section" *ngIf="!isObserver">
            <h5 class="section-title fw-bold">Your Comment</h5>
            <textarea 
                class="form-control" 
                rows="4"
                formControlName="comment"
            ></textarea>
            <div class="text-muted mt-2 small">
                Please provide your comments before accepting or rejecting this agenda item
            </div>
        </div>
        </div>

        <!-- Dialog Footer -->
        <div class="dialog-footer d-flex justify-content-between align-items-center">
            <button type="button" class="btn btn-danger" (click)="onLeaveMeeting()">Leave Meeting</button>
            <!-- Action buttons (Hidden for Observers) -->
            <div class="d-flex gap-2" *ngIf="!isObserver">
                <button type="button" 
                    class="btn reject-btn" 
                    [class.selected]="rejectedAgendaItems.has(currentAgendaIndex)"
                    (click)="onReject()">Reject</button>
                <button type="button" 
                    class="btn defer-btn" 
                    [class.selected]="deferredAgendaItems.has(currentAgendaIndex)"
                    (click)="onDefer()">Reserved</button>
                <button type="button" 
                    class="btn accept-btn" 
                    [class.selected]="acceptedAgendaItems.has(currentAgendaIndex)"
                    (click)="onAccept()">Accept</button>
            </div>
            <!-- Observer message (shown only for Observers) -->
            <div class="text-muted" *ngIf="isObserver">
                <i class="fas fa-eye me-2"></i>Observer Mode - Read Only
            </div>
        </div>
    </form>
</div>

